import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { toQueryParams } from '@app/shared/utils';
import {
  CallTypesToCheckApiModel,
  CallTypesToImportApiModel,
  DuplicatesForCallApiModel,
  ExternalCallTypesApiModel,
  ExternalCallTypesRequestModel,
  PendingTasksToCompleteCad
} from '../api-models';
import { HttpClientService } from './http-client.service';

@Injectable()
export class ExternalCallTypesService {
  public readonly apiUrl = 'external-call-types';

  constructor(private readonly http: HttpClientService) {}

  public fetchCallTypes(params: ExternalCallTypesRequestModel): Observable<ExternalCallTypesApiModel> {
    return this.http
      .get<ExternalCallTypesApiModel>(`${this.apiUrl}/search`, { params: toQueryParams(params) })
      .pipe(map((response) => new ExternalCallTypesApiModel().deserialize(response)));
  }

  public passToImport(model: CallTypesToImportApiModel): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/import`, model);
  }

  public getDuplicatesInCad(model: CallTypesToCheckApiModel): Observable<Array<DuplicatesForCallApiModel>> {
    return this.http.post<Array<DuplicatesForCallApiModel>>(`${this.apiUrl}/get-duplicates`, model);
  }

  public completeDuplicates(model: PendingTasksToCompleteCad): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/complete-duplicates`, model);
  }
}
